@import "../../../styles/variables";
.facet {
  border: 1px solid white;
  box-sizing: border-box;
  margin-right: 0;
  margin-bottom: 20px;

  &-horizontal {
    width: 278px;
    height: 48px;
    border: 1px solid #e6e6e6;
    background-color: #ffffff;
  }

  @media (min-width: $uiaas-tablet) {
    margin: 0px 20px 20px 4px;
  }
  &__checkbox {
    display: flex;
    padding: 4px 0 8px 0;
    font-size: 14px;
    font-weight: normal;
    color: var(--se-black);
  }

  &__title {
    font-size: 14px;
    margin: 16px 6px 15px 0;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  &__header {
    text-decoration: none;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-bottom: none;
    justify-content: space-between;
    cursor: pointer;
    &-horizontal {
      text-decoration: none;
      display: flex;
      align-items: center;
      padding: 0 20px;
      justify-content: space-between;
      border: none;
    }
  }

  &__header-link {
    color: #333333 !important;
    text-decoration: none;
  }

  &__show-header {
    border-top: none !important;
  }

  &__accordion {
    transition: all 0.4s ease-in-out;
    &--open {
      opacity: 1;
      height: auto;
    }

    &--close {
      height: 0px;
      opacity: 0;
    }
  }

  &__body {
    background-color: #ffffff;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    padding: 16px;
    z-index: 1;
    &--open {
      opacity: 1;
      height: auto;
      border-top: 1px solid var(--se-divider, #e6e6e6);
      &-horizontal {
        position: relative;
        background-color: #ffffff;
        box-shadow: 0px 7px 18px -7px rgba(51, 51, 51, 0.18);
      }
    }

    &--close {
      height: 0px;
      opacity: 0;
      padding: 0px 20px;
      &-horizontal {
        height: 0px;
        padding: 0px 20px;
      }
    }
  }

  &__body-single-option {
    @extend .facet__body;
    padding: 0px;
    padding-top: 16px;
    padding-bottom: 16px;
    border-top: 1px solid var(--se-divider, #e6e6e6);
    &--open {
      @extend .facet__body--open;
    }

    &--close {
      height: 0px;
      opacity: 0;
      padding: 0px 20px;
    }
  }

  &__arrow {
    height: 8px;
    width: 8px;
    transform: rotate(-225deg);
    border-top: 1px solid;
    border-right: 1px solid rgb(51, 51, 51);
    transition: 0.2s;
    margin-bottom: 2px;

    &--rotated {
      @extend .facet__arrow;
      transform: rotate(-45deg);
      transform-origin: 100% 50%;
      margin-bottom: 0px;
    }
  }
}

.facet[dir="rtl"] {
  @media (min-width: $uiaas-tablet) {
    margin: 0px 4px 20px 20px;
  }
}

.facet__hide {
  display: none;
}

.hide-filter__icon {
  display: flex;
  height: 100%;
  align-items: center;
  position: absolute;
  left: 4px;
}

.hide-filter__text {
  margin-top: 4px;
  padding-left: 26px;
  position: relative;
  display: flex;
  align-items: center;
}

[dir="rtl"] .hide-filter__icon {
  left: unset;
  right: 4px;
}

[dir="rtl"] .hide-filter__text {
  padding-left: 0;
  padding-right: 26px;
}

.facets__controls {
  display: flex;
  justify-content: space-between;
  padding-bottom: 4px;
  min-height: 30px;
  @media (min-width: $uiaas-tablet) {
    padding-bottom: 0;
    min-height: 35px;
  }
}

.horizontal-panel {
  display: flex;
  flex-direction: initial;
  flex-wrap: wrap;
}

.horizontal-reset-all {
  margin-top: 16px;
  display: inline-block;
}

.facet-container {
  @media (min-width: $uiaas-tablet) {
    margin-right: 20px;
    margin-top: 20px;
    margin-left: 4px;
  }
}

.search_facet_title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}

.search-input-container {
  position: relative;
  margin-top: 8px;
}

.search-facets-horizontal {
  margin-top: 10px;
  margin-bottom: 44px;
}

.facet-date-body {
  height: 196px;
  padding: 0px 20px 20px 20px;
}

.date-facet-input-label {
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.23px;
  display: block;
}

.date-facet-input-label-end-date {
  margin-top: 20px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.23px;
  display: block;
}

.date-facet-input {
  margin-top: 20px;
  display: block;
  width: 98%;
  height: 32px;
  border-radius: 6px;
  border: 2px solid #808080;

  &-error {
    @extend .date-facet-input;
    border: 2px solid #b10043;
  }
}

.date-facet-input-validation-error {
  margin-top: 20px;
  display: block;
  color: #b10043;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

[dir="rtl"] .facet-container {
  @media (min-width: $uiaas-tablet) {
    margin: 0;
  }
}

.single-option-filter-list {
  --se-list-item-selected-background: none;
}

.single-option-item-label {
  font-size: 14px;
  line-height: 20px;
}

.product-catalog-reset-all-tooltip-content {
  display: flex;
  width: 170px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.facet-product-catalog {
  position: sticky;
}

.tooltip__container {
  position: relative;
}

.product-catalog-tooltip {
  display: inline-flex;
  direction: ltr;
  position: absolute;

  .product-catalog-tooltip-content {
    color: var(--se-alternative-contrast, #333333);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    visibility: hidden;
    z-index: 0;
    left: auto;
    right: auto;
    top: -70px;
    opacity: 0;
    transition:
      visibility 0.3s ease-in-out,
      opacity 0.3s ease-in-out;
    background-color: white;
    padding: 8px;
    position: absolute;
    width: 190px;
    border-radius: 3px;
    box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.38);

    &::after {
      content: "";
      position: absolute;
      top: 56px;
      right: 50%;
      border-width: 8px;
      border-style: solid;
      border-color: white transparent transparent transparent;
    }
  }

  &:hover .range-tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}

.uiaas-search-facet__checkbox {
  --se-success: var(--qds-theme-signature-color-default, #008a16);
}

.show-more-button-container {
  margin-left: 16px;
}

.show-more-button--qds-button {
  --qds-control-input-padding-horizontal: 0px;
}

.ffn-header-label {
  padding: 15px 0px 6px 10px;
}

.ffn-header-label-wraper {
  display: flex;
  align-items: center;
}
